/** The URL is the sole owner of staff building context. No storage or sentinel IDs. */
export function selectedBuilding(pathname: string, search: string): string | undefined {
  const params = new URLSearchParams(search);
  const buildingPath = /^\/buildings\/([^/]+)(?:\/|$)/.exec(pathname) ?? /^\/developments\/([^/]+)\/contacts$/.exec(pathname) ?? /^\/compliance\/evidence-pack\/([^/]+)$/.exec(pathname);
  return buildingPath && buildingPath[1] !== 'areas' ? buildingPath[1] : params.get('building') ?? undefined;
}
export function withBuildingScope(to: string, building: string | undefined): string {
  if (!to.startsWith('/') || to.startsWith('//') || to.startsWith('/portal') || to.startsWith('/procurement/respond')) return to;
  const url = new URL(to, 'https://staff.invalid');
  const ownBuilding = selectedBuilding(url.pathname, '');
  const selected = ownBuilding ?? url.searchParams.get('building') ?? url.searchParams.get('developmentId') ?? building;
  url.searchParams.delete('developmentId');
  if (selected) url.searchParams.set('building', selected);
  return `${url.pathname}${url.search}${url.hash}`;
}
